import React from 'react';
import { Link } from 'react-router-dom';
import { MdTrendingUp, MdOutlineLightbulb, MdOutlineAttachMoney, MdOutlinePeople, MdOutlineSettings } from 'react-icons/md';
import styles from "./GestaoEmpresa.module.css";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";

function GestaoEmpresarial() {
  return (
    <div className={styles.paginaGestao}> 
      <section className={styles.bannerGestao}>
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerConteudo}>
            <h1>Gestão Empresarial</h1>
            <p>Promova a integração estratégica de todos os departamentos corporativos por meio de planejamento, estruturação e liderança, visando a expansão sustentável da organização.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnCyan}`}>Entre em Contato</Link>
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Os 4 Pilares da Gestão</h2>
            <h3 className={styles.subtituloAzul}>Fundamentos da Gestão Corporativa</h3>
            <p>A excelência administrativa fundamenta-se em quatro pilares essenciais, assegurando diretrizes claras e metodologias precisas para o alcance dos objetivos institucionais.</p>
            
            <div className={styles.pilaresList}>
              <div className={styles.pilarItem}>
                <span className={styles.pilarNumero}>1</span>
                <div>
                  <strong>Planejamento</strong>
                  <p>Estabelecimento de metas estratégicas, formulação de planos de expansão e análise aprofundada do cenário competitivo.</p>
                </div>
              </div>
              <div className={styles.pilarItem}>
                <span className={styles.pilarNumero}>2</span>
                <div>
                  <strong>Organização</strong>
                  <p>Estruturação departamental, alocação otimizada de recursos corporativos e mapeamento rigoroso de processos operacionais.</p>
                </div>
              </div>
              <div className={styles.pilarItem}>
                <span className={styles.pilarNumero}>3</span>
                <div>
                  <strong>Liderança</strong>
                  <p>Gestão estratégica de capital humano, engajamento de equipes multidisciplinares e direcionamento para tomadas de decisão assertivas.</p>
                </div>
              </div>
              <div className={styles.pilarItem}>
                <span className={styles.pilarNumero}>4</span>
                <div>
                  <strong>Controle</strong>
                  <p>Monitoramento contínuo de indicadores de performance (KPIs), avaliação analítica de resultados e implementação de ações corretivas.</p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.imagemWrapper}>
            <img 
              src={img1}
              alt="Reunião de planejamento estratégico" 
              className={styles.imagemEspaco} 
            />
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgClaro}`}>
        <div className={`${styles.containerGrid} ${styles.gridInvertido}`}>
          
          <div className={styles.imagemWrapper}>
            <img 
              src={img2}
              alt="Integração de setores da empresa" 
              className={styles.imagemEspaco} 
            />
          </div>

          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Visão Sistêmica</h2>
            <h3 className={styles.subtituloAzul}>Integração Multidisciplinar</h3>
            <p>A gestão empresarial transcende o mero controle financeiro, promovendo a sinergia entre departamentos vitais para assegurar a eficiência e a fluidez das operações.</p>
            
            <div className={styles.tagsContainer}>
              <div className={styles.tagItem}>
                <MdOutlineAttachMoney className={styles.tagIcon} />
                <span><strong>Financeira</strong> (Gestão de Fluxo e Capital)</span>
              </div>
              <div className={styles.tagItem}>
                <MdOutlineLightbulb className={styles.tagIcon} />
                <span><strong>Contábil</strong> (Conformidade e Escrituração)</span>
              </div>
              <div className={styles.tagItem}>
                <MdOutlinePeople className={styles.tagIcon} />
                <span><strong>Recursos Humanos</strong> (Gestão de Talentos)</span>
              </div>
              <div className={styles.tagItem}>
                <MdTrendingUp className={styles.tagIcon} />
                <span><strong>Marketing</strong> (Posicionamento e Receita)</span>
              </div>
              <div className={styles.tagItem}>
                <MdOutlineSettings className={styles.tagIcon} />
                <span><strong>Operacional</strong> (Cadeia de Produção)</span>
              </div>
            </div>
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Objetivos Estratégicos</h2>
            <h3 className={styles.subtituloAzul}>O Impacto Direto na Organização</h3>
            <p>A adoção de práticas sólidas de Gestão Empresarial substitui o gerenciamento reativo de crises por um planejamento estruturado, garantindo previsibilidade e segurança institucional.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnAzul}`} style={{marginTop: '1.5rem'}}>
              Falar com um Consultor
            </Link>
          </div>

          <div className={styles.beneficiosStack}>
            <div className={styles.beneficioRow}>
              <div className={styles.bolaCyan}></div>
              <p><strong>Otimização estrutural</strong> da corporação em todos os seus níveis hierárquicos.</p>
            </div>
            <div className={styles.beneficioRow}>
              <div className={styles.bolaCyan}></div>
              <p><strong>Maximização da eficiência</strong> operacional e da produtividade das equipes.</p>
            </div>
            <div className={styles.beneficioRow}>
              <div className={styles.bolaCyan}></div>
              <p><strong>Mitigação de custos</strong> operacionais e eliminação de gargalos processuais.</p>
            </div>
            <div className={styles.beneficioRow}>
              <div className={styles.bolaCyan}></div>
              <p><strong>Tomada de decisão executiva</strong> fundamentada em dados analíticos e métricas precisas.</p>
            </div>
            <div className={styles.beneficioRow}>
              <div className={styles.bolaCyan}></div>
              <p><strong>Escalabilidade e crescimento</strong> contínuo e sustentável a longo prazo.</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default GestaoEmpresarial;